import $ from "cash-dom";
import {commonCalculatorComponent} from "./common";

export const standardCalculatorComponent = (root) => {
    const $r = $(root);
    const $formGroups = {
        energySavings: $r.find('#form-group-energy-savings'),
        costs: $r.find('#form-group-costs'),
        ownResources: $r.find('#form-group-own-resources'),
        contribution: $r.find('#form-group-contribution'),
    };

    const {
        inputs,
        parseValue,
        formatValue,
        setError,
        clearError,
        validate,
        isValid,
    } = commonCalculatorComponent($r, $formGroups);

    let mode = 'costs';

    const getMax = energySavings => energySavings >= 30 ? (energySavings > 60 ? 19000 : 14000) : 0;
    const calculate = (energySavings, needed) => Math.min(getMax(energySavings), needed);

    const recalculate = {
        costs: () => {
            const energySavings = parseValue(inputs.energySavings.value);
            const costs = parseValue(inputs.costs.value);

            const contribution = calculate(energySavings, costs / 2.0);
            const ownResources = costs - contribution;

            inputs.contribution.value = formatValue(contribution);
            inputs.ownResources.value = formatValue(ownResources);
        },
        ownResources: () => {
            const energySavings = parseValue(inputs.energySavings.value);
            const ownResources = parseValue(inputs.ownResources.value);


            const contribution = calculate(energySavings, ownResources);
            const costs = ownResources + contribution;

            inputs.contribution.value = formatValue(contribution);
            inputs.costs.value = formatValue(costs);
        },
    };

    const onInput = key => {
        validate(key, setError);

        if (isValid('energySavings') && isValid(mode))
            recalculate[mode]();
    };

    inputs.energySavings.oninput = () => onInput('energySavings');
    inputs.costs.oninput = () => {
        mode = 'costs';
        clearError('ownResources');
        onInput('costs');
    }
    inputs.ownResources.oninput = () => {
        mode = 'ownResources';
        clearError('costs');
        onInput('ownResources');
    };
};